import moment from 'moment';
import { getMomentDateFromObject } from 'helpers/datetime';
export const isMinor = (dateOfBirth, adultYears = 18)=>{
    if (!dateOfBirth) {
        return false;
    }
    let momentDate;
    if (typeof dateOfBirth === 'object') {
        momentDate = getMomentDateFromObject(dateOfBirth);
    } else if (typeof dateOfBirth === 'string') {
        momentDate = moment(new Date(dateOfBirth));
    }
    return momentDate.isAfter(moment().subtract(adultYears, 'years'));
};
